import stipulate, { resolveUrl } from 'stipulate';
import urlJoin from 'url-join';

import { baseUrl, baseOptions } from './base';


export const tldsCollection = function(options = {}) {
  const { apiUrl = '', query = '' } = options;
  const url = resolveUrl(urlJoin(apiUrl, baseUrl, 'pb/tlds/'), query);

  return stipulate(url, baseOptions);
};

export default {
  tldsCollection
};
